import styled, { css } from 'styled-components';

export const StatusInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 89vh;
  width: 100%;

  ${ props => props.typeLength > 4 && css`overflow-x: scroll;` }
`;
